import { render } from "./ProdutoLote.vue?vue&type=template&id=16d452fe"
import script from "./ProdutoLote.vue?vue&type=script&lang=js"
export * from "./ProdutoLote.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__